const defaultCompanies = {};
const companiesList = (state = defaultCompanies, action) => {
  switch (action.type) {
    case 'GET_COMPANIES_LIST_SUCCESS':
      return { ...action.companiesList };
    default:
      return state;
  }
};

export default companiesList;
